// Ruubyn — global.js
// Minimal vanilla JS for theme-wide behaviors.
// Component-specific JS lives in section-level files loaded via {% javascript %} tags.

// Newsletter / waitlist form handler — submits to Klaviyo or Shopify customer endpoint
class NewsletterForm extends HTMLFormElement {
  connectedCallback() {
    this.addEventListener('submit', this.onSubmit.bind(this));
  }

  async onSubmit(event) {
    event.preventDefault();
    const formData = new FormData(this);
    const submitBtn = this.querySelector('[type="submit"]');
    const status = this.querySelector('[data-status]');

    if (submitBtn) submitBtn.disabled = true;
    if (status) status.textContent = '';

    try {
      const response = await fetch(this.action, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });

      if (response.ok) {
        if (status) {
          status.textContent = this.dataset.successMessage || "You're on the list. Welcome.";
          status.classList.add('is-success');
        }
        this.reset();
      } else {
        throw new Error('Submission failed');
      }
    } catch (err) {
      if (status) {
        status.textContent = this.dataset.errorMessage || 'Something went wrong. Please try again.';
        status.classList.add('is-error');
      }
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  }
}

if (!customElements.get('newsletter-form')) {
  customElements.define('newsletter-form', NewsletterForm, { extends: 'form' });
}

// Cart trigger handled by cart.js (drawer slide-in).

// ─────────────────────────────────────────────────────────────
// Hero scroll cue — scrolls to next section past the hero
// ─────────────────────────────────────────────────────────────
document.addEventListener('click', (e) => {
  const cue = e.target.closest('.hero-super__scroll-cue');
  if (!cue) return;
  e.preventDefault();
  const hero = cue.closest('.hero');
  const next = hero?.nextElementSibling;
  if (next) {
    next.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    window.scrollBy({ top: window.innerHeight * 0.85, behavior: 'smooth' });
  }
});

// ─────────────────────────────────────────────────────────────
// Scroll-reveal — adds .is-in-view to .section when it enters
// the viewport. CSS animates the children based on this class.
// ─────────────────────────────────────────────────────────────
(function() {
  if (typeof IntersectionObserver === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const sections = document.querySelectorAll('.section, .marquee, .hero, .site-footer, .product-card, .showcase');
  if (!sections.length) return;

  // A section taller than the viewport can never be 8% visible (on mobile the
  // whole PDP is one ~11,000px section), so it would stay hidden forever.
  // Tall sections reveal as soon as they enter; the rest keep the 8% rule.
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const tall = entry.boundingClientRect.height > window.innerHeight;
      if (tall || entry.intersectionRatio >= 0.08) {
        entry.target.classList.add('is-in-view');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: [0, 0.08], rootMargin: '0px 0px -40px 0px' });

  sections.forEach(s => io.observe(s));
})();
